export const CONSTANT = {
  USUARIO_PAGO: "pagosLinkUsr",
  ERROR_PAGO: "Error procesando el pago",
  DECLINADA: "Declinada.",
};

export const MENSAJES = {
  LINK_CADUCADO: {
    TITULO: 'El enlace de pago ha caducado',
    DESCRIPCION: 'Por favor solicítalo nuevamente'
  },
  BALANCE_POLIZA: {
    TITULO: 'Balance Póliza',
    DESCRIPCION: 'La póliza que intenta pagar se encuentra con balance $0'
  },
  POLIZA: {
    TITULO: 'Estatus Póliza'
  },
  DOMICILIACION: {
    TITULO: 'Domiciliación de póliza',
    DESCRIPCION: 'Inscribe tu tarjeta de forma segura para pagos automáticos haciendo clic aquí:'
  },
  NOTIFICACION_PAGO: {
    MENSAJE_RECIBO_HUMANO: 'Humano No.',
    MENSAJE_RECIBO_TRANSACCION: 'No. Aprobación de Tarjeta.'
  }
}

export const PRODUCT_TYPES = {
  BUEN_VIAJE: "BUEN_VIAJE",
  GENERIC: "GENERIC",
};

export const PAYMENT_NOTIFICATION_URLS = {
  GENERIC: "mbp-pagoenlinea/parse/classes/linkdepago",
};

export const PRODUCT_TYPES_PER_BRANCH = {
  BUEN_VIAJE: ["93"],
};

export const URL_CANALES = {
  OFV: 'https://oficinavirtual.humano.com.do/OficinaVirtual',
  APP_HUMANO_IOS: 'https://apps.apple.com/do/app/humano/id905470413?l=en',
  APP_HUMANO_ANDROID: 'https://play.google.com/store/apps/details?id=com.arshumano.app.android'
}
